import { FC, useState, HTMLAttributes } from "react";
import styles from "./InputDate.module.sass";
import cn from "classnames";

interface InputDateProps extends HTMLAttributes<HTMLInputElement> {
	title: string;
	value: string;
	onChange: (e: any) => void;
	required?: boolean;
	submitError?: boolean;
	name: string;
	min?: string;
	max?: string;
}

export const InputDate: FC<InputDateProps> = ({
	className,
	title,
	value,
	onChange,
	required = false,
	submitError,
	name,
	min,
	max,
	...props
}) => {
	const [isFocus, setIsFocus] = useState<boolean>(false);

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (max && new Date(e.target.value) > new Date(max)) {
			const newEvent = {
				target: {
					value: max,
				},
			};
			onChange(newEvent);
		} else onChange(e);
	};

	return (
		<div className={cn(className, styles.wrp)}>
			<span
				className={cn(
					styles.title,
					isFocus ? styles["title-focused"] : styles["title-unfocused"],
					// if (!date || (new Date(date) < new Date("2017-01-01")) || (new Date(date) > new Date("3000-12-31"))) {
					submitError &&
						(!value || new Date(value) < new Date(`${min}`) || new Date(value) > new Date(`${max}`)) &&
						"error-input-title",
				)}>
				{title} {required && <span className="red">*</span>}
			</span>
			<input
				value={value}
				onChange={changeHandler}
				onFocus={() => setIsFocus(true)}
				onBlur={() => setIsFocus(false)}
				name={name}
				className={cn(
					submitError && (!value || new Date(value) < new Date(`${min}`) || new Date(value) > new Date(`${max}`))
						? styles["input-error"]
						: styles["input-default"],
					styles.input,
				)}
				type="date"
				min={min}
				max={max}
				{...props}
			/>
		</div>
	);
};
